export default function Index() {
    return (
        <div class="p-5 text-white">
            <label>u stinke!</label>
        </div>
    );
}